import { useMemo } from 'react';
import { useAuth } from '../contexts/AuthContext';
import type { PagePermission } from '../types/auth';

/**
 * Hook to check if the current user has view/edit permission for a page
 */
export function usePagePermissions(pageUrl: string): PagePermission & { isLoading: boolean } {
    const { user, isLoading } = useAuth();

    return useMemo(() => {
        if (isLoading || !user) {
            return { canView: false, canEdit: false, isLoading };
        }

        const page = user.accessiblePages.find(p => p.pageUrl === pageUrl);

        return {
            canView: page?.canView ?? false,
            canEdit: page?.canEdit ?? false,
            isLoading: false,
        };
    }, [user, pageUrl, isLoading]);
}
